export interface CategoryContract {
  id: number;
  uuid: string;
  name: string;
  active_icon_url: string;
  inactive_icon_url: string;
  color: string;
}
